import { Editor } from '@tiptap/core';

export function getEditorContainer(editor: Editor | null): HTMLElement | null {
  if (!editor) return null;

  const editorElement = editor.view.dom;

  let current = editorElement.parentElement;
  while (current && current !== document.body) {
    if (current.hasAttribute('data-editor-container')) {
      return current;
    }
    current = current.parentElement;
  }

  return null;
}
